function load_insticator()
{
    var instigator_loaded = false;
    var statusBox = document.getElementById("insticator-ad-wrapper");
    var observer = new IntersectionObserver(handler);

    observer.observe(statusBox);

    function handler(entries, observer) {
        for (entry in entries) {
            if (entries[entry].isIntersecting) {
                if(!instigator_loaded){
                    load_observer_insticator();
                    stop_listening();
                }
            }
        }
    }

    function stop_listening(){
        console.log('stop listening');
        observer.unobserve(document.getElementById("insticator-ad-wrapper"));
    }

    function load_observer_insticator(){
        
        if(instigator_loaded){
            return;
        }

        (function (a, c, s, u){'Insticator'in a || (a.Insticator={ad:{loadAd: function (b){Insticator.ad.q.push(b)}, q: []}, helper:{}, embed:{}, version: "4.0", q: [], load: function (t, o){Insticator.q.push({t: t, o: o})}}); var b=c.createElement(s); b.src=u; b.async=!0; var d=c.getElementsByTagName(s)[0]; d.parentNode.insertBefore(b, d)})(window, document, 'script', '//d3lcz8vpax4lo2.cloudfront.net/ads-code/697d3ca0-daa5-4ba9-8579-49bcbab41773.js');

        if($('body').hasClass('home')){
            Insticator.ad.loadAd("div-insticator-ad-1");
            $('#div-insticator-ad-1').css('height', '280px');
            Insticator.ad.loadAd("div-insticator-ad-2");
            console.log('Insticator-loaded - Home');
        } else {
            Insticator.ad.loadAd("div-insticator-ad-3");
            $('#div-insticator-ad-3').css('height', '280px');
            Insticator.ad.loadAd("div-insticator-ad-4");
            console.log('Insticator-loaded - Inner');
        }

        Insticator.load("em", {id: "fa650b51-8c4e-432d-9bd1-eca8d48b39ab"});
        //stop loading the script
        instigator_loaded = true;

    }
}

export default load_insticator;